/**
 * checkCredentials module
 * Checks if the AWS credentials are valid or whether they need to be refreshed
 * or if user needs to be redirected to login page
 */
import retrieveUser from './retrieveUser';
import getCurrentUser from './getCurrentUser';

function checkCredentials() {
  if (window.redirectBool) {
    if (AWS.config.credentials == null || typeof localStorage.zmailSchoolName === 'undefined') {
      return Promise.reject(
        new Error(
          'Unable to refresh credentials when AWS credentials or zmailSchoolName do not exist'
        )
      );
    } else if (!AWS.config.credentials.needsRefresh()) {
      return AWS.config.credentials.refreshPromise();
    } else if (AWS.config.credentials.expired) {
      window.location.replace(`${process.env.ZCRUIT_BASE_URL}/login`);
    }

    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    refreshCredentials()
      .then(() => {
        var cognitoUser;
        if (window.redirectBool) {
          cognitoUser = username === 'undefined' ? getCurrentUser() : getUser(username);
        } else {
          cognitoUser = getCurrentUser();
        }
        if (cognitoUser == null) return Promise.reject(new Error('Unable to get current user'));
        resolve(cognitoUser);
      })
      .catch((err) => {
        clearLocalStorage();
        // @TODO : redirect to login
        reject(err);
      });
  });
}

function refreshCredentials() {
  if (AWS.config.credentials == null || typeof localStorage.zmailSchoolName === 'undefined') {
    return Promise.reject(
      new Error(
        'Unable to refresh credentials when AWS credentials or zmailSchoolName do not exist'
      )
    );
  } else if (!AWS.config.credentials.needsRefresh()) {
    return AWS.config.credentials.refreshPromise();
  } else {
    return retrieveUser();
  }
}

function clearLocalStorage() {
  localStorage.zmailSchoolName = '';
  localStorage.zmailUsername = '';
}

export default checkCredentials;



// WEBPACK FOOTER //
// ./src/authentication/checkCredentials.js